export default __webpack_public_path__ + "/assets/infographic.jpg";